import styled from 'styled-components';

export const PageLayout = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`;
